<template>
	<div >
		<div class="custom-label-header">
			{{ checkLabel(phone)}}
		</div>
		<div class="custom-label-body">
			<el-row :gutter="20">
				<!--
				<el-col :span="10">
					<el-form-item label="Larga distancia"
					              :prop=" formProp + '.areaCode'"
					              :rules="{ validator: checkAreaCode, trigger: ['blur','change'] }">
						<NumericOnlyInput v-model="phone.areaCode"
						                  :disabled="onlyRead"
						                  placeholder="Larga distancia">
						</NumericOnlyInput>
					</el-form-item>
				</el-col>
				-->

				<el-col :span="24">
					<el-form-item label="Número"
					              :prop=" formProp + '.phone'"
					              :rules="{max: 8, validator: checkPhone, trigger: ['blur','change'] }">
						<NumericOnlyInput v-model="phone.phone"
										  maxLength="8"
						                  :disabled="onlyRead"
						                  placeholder="Número"
						                  >
						</NumericOnlyInput>
					</el-form-item>
				</el-col>


			</el-row>
			<el-row :gutter="20">
				<el-col :span="24">

					<div v-if="phone.used_type_id != 3"
					     style="height: 128px;color: transparent">
						.
					</div>
					<el-form-item label="Notas"
					              v-if="phone.used_type_id == 3">


						<el-input placeholder="Notas"
						          v-my-only-alphanumeric
						          type="textarea"
						          :disabled="onlyRead"
						          v-model="phone.note">
						</el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</div>


	</div>
</template>

<script>
	import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
	import NumericOnlyInput from '@/components/partials/NumericOnlyInput';
	export default {
		components: {
			NumericOnlyInput,
		},
		props: {
			formProp: {
				type: String,
				required: true
			},
			model: {
				type: Object,
				required: true
			},
			index: {
				type: Number,
				required: true
			},
			items: {
				type: Array,
				required: true
			},
			typeOfPerson:{
				type: Number,
				required: true
			},
		},

		computed: {
			phone() {
				return this.model;
			},
			...mapGetters('young', {
				onlyRead: 'onlyRead'
			}),
		},
		methods: {

			checkLabel(value) {
				if (!value) return '';
				if (value.used_type_id == 1) return 'Móvil';
				if (value.used_type_id == 2) return 'Hogar';
				return 'Recados';
			},
			checkAreaCode(rule, value, callback) {
				let minLenght = 2;
				let maxLenght = 10;
				if (value) {
					if (value.toString().length < minLenght || value.toString().length > maxLenght) {
						callback(new Error(`La longitud debe ser de ${minLenght} a ${maxLenght} caracteres.`));
					}
				}
				callback();
			},
			checkPhone(rule, value, callback) {
				let minLenght = 8;
				let maxLenght = 8;
				if (value) {
					if (value.toString().length < minLenght || value.toString().length > maxLenght) {
						callback(new Error(`La longitud debe ser de ${minLenght} caracteres.`));
					}
				}
				callback();
			},
		},

	}
</script>

<style scoped>
	.box-card {
		-webkit-box-shadow: 0 2px 12px 0 transparent;
	}

	.custom-label-body {
		border: 1px solid rgb(193, 193, 193);
		padding: 23px 10px 10px 10px;
		word-break: break-all;
		line-height: normal;
		font-size: 14px;
	}

	.custom-label-header {
		border: 1px solid #c1c1c1;
		position: relative;
		width: 80%;
		padding: 0px 5px 0px 5px;
		margin: 0px 0px -18px 5px;
		word-break: break-all;
		font-size: 16px;
		font-weight: bold;
		background: #f1f1f1;
		color: #5B5B5F;
	}

</style>